// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f6XVDdtZweSiRKJg1Hln {
  display: flex;
  justify-content: space-evenly;
  margin-top: 15svh;
}

.Ud22J4dO5W_pqWWTXmJy {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  width: 33%;
  max-width: 350px;
  background-color: #44224455;
  border-radius: 15px;
}

.Ud22J4dO5W_pqWWTXmJy > p {
  font-size: 16px;
  margin-bottom: 15px;
}

.Ud22J4dO5W_pqWWTXmJy > h2 {
  border-bottom: 1px solid #eee;
}
`, "",{"version":3,"sources":["webpack://./src/Views/LevelUp/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".cards {\n  display: flex;\n  justify-content: space-evenly;\n  margin-top: 15svh;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 10px;\n  width: 33%;\n  max-width: 350px;\n  background-color: #44224455;\n  border-radius: 15px;\n}\n\n.card > p {\n  font-size: 16px;\n  margin-bottom: 15px;\n}\n\n.card > h2 {\n  border-bottom: 1px solid #eee;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cards": `f6XVDdtZweSiRKJg1Hln`,
	"card": `Ud22J4dO5W_pqWWTXmJy`
};
export default ___CSS_LOADER_EXPORT___;
